import {
  Component,
  AfterContentInit,
  OnDestroy,
  ElementRef
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';

import { PlycaDataService } from '../../services/plyca.service';
import { UIService } from '../ui.service';

import { UserService } from '../user.service';
import { TaskService } from './task.service';

import {
  TaskDTO,
  TaskTypeDTO,
  InboxDTO
} from '../api/plyca-dtos';
import * as lodash from 'lodash';
import { Store } from '@ngrx/store';
import { AppState } from '../store/AppState';
import { SET_USERPREFS } from '../store/userPrefs';

import { UserPrefs, TasksViewPrefs } from '../api/UserPrefs-dto';
import { HelpService, HelpType } from '../components/common/help/help.service';
import { dossierBasicInfoComponent } from '../dossiers/components/dossierBasicInfo.component';
import {
  multiSignatureComponent
} from './multiSignature/multiSignature.component';
import { TranslateService } from '@ngx-translate/core';
import { HeaderActionsService } from '../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../components/common/waitLoading/wait-loading.service';
import { catchError, finalize, tap } from 'rxjs/operators';
import { AppConfiguration } from '../conf/app.configuration';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { MultiTaskActionComponent, MultiTaskConfig } from './multiTaskAction/multiTaskAction.component';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { ActionDefinitionDTO } from '../api/plyca-dtos-v2';
import { PaginationDTO } from '../api/PaginationModel';
import { Configuration } from '../conf/app.constants';
import { FormService } from '../components/forms/form.service';

@Component({
  selector: 'tasks',
  templateUrl: 'tasks.template.html',
  providers: [DialogService, UIService]
})
export class tasksComponent extends BaseComponent implements AfterContentInit, OnDestroy {

  // Control de carga del componente
  loaded = false;

  errro = false;

  // Referencia a la lista de tareas almacenada en el store
  pendingTasks: Observable<any>;
  // Lista de tareas que se utiliza en la pagina. Inicialmente copia del store. Cambia si se aplican filtros de servidor.
  tasks: TaskDTO[];
  // Lista de tareas con filtros rapidos (cliente) aplicados
  filteredTasks: TaskDTO[];

  // INFORMACION DE LA PANTALLA ALMACENADA EN SESION
  userPrefs: UserPrefs;

  activeFilter = false;

  lastLoad: Date;
  loading: boolean;
  rows = 0;
  totalRecords = 0;

  // groupIndex = 2;
  // selectedGroup: string = undefined;
  groups = undefined;
  selectedGroup: any;
  // selectedGroupObj: any;

  // // VARIABLES PARA ALMACENAR LOS FILTROS RAPIDOS
  // filters: any = {
  //     'filterText': '',
  //     'filterActiveTasks': true,
  //     'filterTipoTarea': '',
  //     'filterDate': '',
  //     'filterBuzon': ''
  // };

  buzonesList: Array<any> = [];

  textDossierFilter = '';
  showDossierFilter = false;
  dossiersList: Array<any> = [];

  private massiveActionsConfig: any[];

  TODAYCOUNT = 0;
  YESTERDAYCOUNT = 0;
  WEEKCOUNT = 0;
  MONTHCOUNT = 0;
  YEARCOUNT = 0;
  OLDCOUNT = 0;

  /**********************************************************************************************/
  /* CHARTS */
  chartTipoTareaField = 'type';
  chartTipoTareaLabels: string[] = [];
  chartTipoTareaData: number[] = [];
  chartTipoTareaKeys: string[] = [];
  chartTipoTareaType = 'doughnut';

  chartTipoExpedienteField = 'division.project.type.identifier';
  chartTipoExpedienteFieldDescription = 'division.project.type.description';
  chartTipoExpedienteLabels: string[] = [];
  chartTipoExpedienteData: number[] = [];
  chartTipoExpedienteKeys: string[] = [];
  chartTipoExpedienteType = 'doughnut';

  chartTipoContratoField = 'division.project.classification.typeCode.identifier';
  chartTipoContratoFieldDescription = 'division.project.classification.typeCode.description';
  chartTipoContratoLabels: string[] = [];
  chartTipoContratoData: number[] = [];
  chartTipoContratoKeys: string[] = [];
  chartTipoContratoType = 'doughnut';

  /* FILTRO DE BUSQUEDA */
  TIPO_FIRMA_MASIVA = true;
  TIPO_OPTATIVA = true;
  TIPO_ASIGNACION = true;
  TIPO_CUMPLIMENTACION = true;
  TIPO_VIRTUAL = true;
  TIPO_ALARMA = true;
  TIPO_OTROS = true;
  TIPO_FIRMA = true;


  clonedDossierList = [];
  MIN_SEARCH_TEXT_LENGHT = 3;

  _chartTipoTareaData: any;
  _chartTipoExpedienteData: any;
  _chartTipoContratoData: any;

  constructor(
    public plycaService: PlycaDataService,
    public taskService: TaskService,
    public userService: UserService,
    public uiService: UIService,
    private route: ActivatedRoute,
    private translate: TranslateService,
    public helpService: HelpService,
    private store: Store<AppState>,
    private headerActionsService: HeaderActionsService,
    private elem: ElementRef,
    private waitService: WaitLoadingService,
    protected dialogService: DialogService,
    protected appConfig: AppConfiguration,
    private _configuration: Configuration,
    public formService: FormService
  ) {
    super();
    this.waitService.startWaiting();
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.HELP_TASKS));
    this.pendingTasks = this.store.select('pendingTasks');
    this.subscribe(this.taskService.lastLoadObservable,
      x => {
        if (x) {
          this.lastLoad = x;
        }
      });
    this.subscribe(this.taskService.loadingStatusObservable,
      x => {
        this.loading = x;
      });
    this.subscribe(this.store
      .select('userPrefs'),
      (prefs: UserPrefs) => {
        this.userPrefs = prefs;

        // inicializar la variable por si no viene en las preferencias
        if (!this.userPrefs) {
          this.userPrefs = new UserPrefs();
        }
        if (!this.userPrefs.tasksViewPrefs) {
          this.userPrefs.tasksViewPrefs = new TasksViewPrefs();
        }
        this.subscribe(this.route.queryParams,
          params => {
            if (params['type']) {
              if (params['type'] === '*') {
                this.userPrefs.tasksViewPrefs.filters.filterTipoTarea = '';
              } else {
                this.userPrefs.tasksViewPrefs.filters.filterTipoTarea =
                  params['type'];
              }
              let thisUserPrefs = this.userPrefs;
              this.store.dispatch(SET_USERPREFS({ userPrefs: thisUserPrefs }));
            }
          });
      });
  }

  ngAfterContentInit(): void {
    this.massiveActionsConfig = this.appConfig.getValue('task.massive.actions');
    // this.headerActionsService.setTaskDescription(this.elem, 'Gestor de tareas', 'fas fa-inbox', this.isLoaded.bind(this));
    this.headerActionsService.setTaskDescription(this.elem, this.translate.instant('MultiTaskAction.Tasks.TaskManager'),
      'fas fa-inbox', this.isLoaded.bind(this));
    // grupo de acciones masivas
    this.createMassiveActions();
    this.subscribe(this.headerActionsService.addAction(
      'General.export.csv',
      'fas fa-download',
      'btn-primary',
      true
    ),
      () => {
        this.exportCSV();
      });
    this.subscribe(this.headerActionsService.addAction(
      'Tasks.updateTaskList',
      'fas fa-sync-alt',
      'btn-primary',
      true
    ),
      () => {
        this.updateTasksList();
      });
    this.subscribe(this.headerActionsService.addAction(
      'Tasks.resetFilters',
      'fas fa-undo',
      'btn-secondary',
      true
    ),
      () => {
        this.clear();
      });
    this.headerActionsService.addDivider();
    this.subscribe(this.headerActionsService.addAction(
      'General.back',
      'fas fa-chevron-left',
      'btn-outline-secondary',
      true
    ),
      () => {
        this.uiService.routeBack();
      });

    //        this.loadFilterSettings();
    this.loadTasks();

    this.groups = [
      { name: '-', code: undefined },
      { name: this.translate.instant('PendingTasks.dossierType'), code: 'division.project.type.description', icon: 'fa fa-sitemap' },
      { name: this.translate.instant('PendingTasks.taskType'), code: 'taskTypeDescription', icon: 'fa fa-sitemap' },
      { name: this.translate.instant('PendingTasks.contractType'), code: 'division.project.classification.typeCode.description', icon: 'fa fa-sitemap' },
      { name: this.translate.instant('PendingTasks.byBuzon'), code: 'inbox.description', icon: 'fa fa-envelope-o' },
      { name: this.translate.instant('PendingTasks.byDossier'), code: 'division.project.contractFolderId', icon: 'fa fa-archive' },
    ];
    if (this.userPrefs?.tasksViewPrefs?.filters?.groupBy) {
      this.selectedGroup = this.groups.find(grp => grp.code === this.userPrefs.tasksViewPrefs.filters.groupBy);
    }
  }

  createMassiveActions() {
    let multiSignatureEnabled = this.appConfig.getValue('multiSignatureEnabled');
    if (this.massiveActionsConfig && this.massiveActionsConfig.length > 0) {
      this.headerActionsService.addActionGroup(
        'massive.actions',
        undefined,
        'fas fa-cog',
        'btn-secondary',
        true
      );
      if (multiSignatureEnabled) {
        this.subscribe(this.headerActionsService.addActionToGroup(
          'massive.actions',
          'MultiSignature.action',
          'fas fa-lg fa-pen-nib',
          'btn-secondary',
          true,
          undefined,
          () => this.tasks?.length > 0
        ),
          () => {
            this.openMultiSignatureComponent();
          });
      }
      this.massiveActionsConfig.forEach(action => {

        this.subscribe(
          // consultar accion
          this.plycaService.query<ActionDefinitionDTO>(this._configuration.ACTIONDEFINICION_SERVICE_URL, {
            actionObjType: 'TASK',
            id: action.config.action
          }).pipe(
            catchError((error: any) => {
              console.warn('Error al consultar la accion', action?.config?.action);
              return EMPTY;
            }),
            tap((result: PaginationDTO<ActionDefinitionDTO>) => {
              if (!result || !result.content || result.content.length === 0) {
                console.warn('Acción no disponible -> ', action?.config?.action);
              } else {
                console.log('Cargamos la acción  -> ', action?.config?.action, 'action.visible:' + eval(action.visible));
                this.subscribe(this.headerActionsService.addActionToGroup(
                  'massive.actions',
                  action.name,
                  action.icon,
                  action.classes,
                  // tslint:disable-next-line:no-eval
                  eval(action.visible),
                  undefined,
                  () => this.tasks?.length > 0
                ),
                  () => {
                    this.openMultiTaskComponent(action.name, action.config);
                  });
              }
            }))
        )
      });
    } else if (multiSignatureEnabled) {
      this.subscribe(this.headerActionsService.addAction(
        'MultiSignature.action',
        'fas fa-lg fa-pen-nib',
        'btn-secondary',
        true,
        () => this.tasks?.length > 0
      ),
        () => {
          this.openMultiSignatureComponent();
        });
    }
  }

  private openMultiTaskComponent(name: string, taskConfig: MultiTaskConfig) {
    let config: DynamicDialogConfig = {
      header: name,
      width: '75%',
      style: { overflow: 'hidden', 'max-height': '90%' },
      styleClass: 'formEdition',
      closeOnEscape: false,
      data: {
        taskConfig: taskConfig
      }
    };
    const dialog = this.dialogService.open(MultiTaskActionComponent, config);
    this.subscribe(dialog.onClose,
      (result) => {
        if (result && result.taskUpdated) {
          this.updateTasksList();
        }
        this.subscribe(this.helpService.showContextHelpObservable(HelpType.HELP_TASKS));
      });
  }

  ngOnDestroy(): void {
    let thisUserPrefs = this.userPrefs;
    this.store.dispatch(SET_USERPREFS({ userPrefs: thisUserPrefs }));
    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  public isLoading(): boolean {
    return this.loading;
  }

  updateTasksList(): void {
    this.waitService.startWaiting();
    this.subscribe(this.taskService.consultaTareasObservable()
      .pipe(finalize(() => {

        this.waitService.cancelWaiting();
      })));
  }

  loadTasks() {
    this.subscribe(this.pendingTasks, x => {
      this.tasks = x;

      this.filteredTasks = this.tasks;
      this.tasks.forEach(task => {
        task['taskTypeDescription'] = this.traduce(task.type);
      })
      // cuenta y clasifica por fecha las tareas
      this.clasificaPorFecha();
      this.clasificaPorBuzon();

      this.updateFilter();
      this.loaded = true;
      this.waitService.cancelWaiting();
    });
    // ,err => {
    //     console.log( 'Error al buscar tareas sin filtro:', err );
    //     this.loaded = true;
    //     this.loadTasks();
    // });
  }

  isActiveFilter(): boolean {
    return this.activeFilter;
  }

  public updateFilter() {
    let _searchText: string = this.userPrefs.tasksViewPrefs.filters.filterText;
    let _filterTipoTarea: string = this.userPrefs.tasksViewPrefs.filters
      .filterTipoTarea;
    let _filterTipoExpediente: string = this.userPrefs.tasksViewPrefs.filters
      .filterTipoExpediente;
    let _filterTipoContrato: string = this.userPrefs.tasksViewPrefs.filters
      .filterTipoContrato;
    let _filterDate: string = this.userPrefs.tasksViewPrefs.filters.filterDate;
    let _filterBuzon: InboxDTO = this.userPrefs.tasksViewPrefs.filters
      .filterBuzon;

    let strFilter: string =
      _searchText + _filterTipoTarea + _filterDate + _filterBuzon + _filterTipoExpediente + _filterTipoContrato;
    this.activeFilter = strFilter.replace(/undefined/g, '') !== '';

    this.filteredTasks = this.tasks.filter((task: TaskDTO) => {
      let taskExpeId = task.division.project.contractFolderId;
      if (!taskExpeId) {
        taskExpeId = '';
      }

      let taskExpeTitle = task.division.project.title;
      if (!taskExpeTitle) {
        taskExpeTitle = '';
      }

      let descExpte = '';
      if (task.division && task.division.name) {
        descExpte = task.division.name;
      }

      let descDivisions = '';
      if (task.division && task.division.name) {
        descDivisions = task.division.name;
        if (
          task.division.parent &&
          task.division.parent.name &&
          task.division.parent.identifier !== '0'
        ) {
          descDivisions += ' - ' + task.division.parent.name;
        }
      }

      // PASO 1. COMPROBAR QUE CUMPLE EL FILTRO DE BUSQUEDA TEXTUAL
      let isValidTask = !_searchText ||
        this.uiService.normalizeAndCompareStrings(taskExpeId, _searchText) ||
        this.uiService.normalizeAndCompareStrings(task.description, _searchText) ||
        this.uiService.normalizeAndCompareStrings(taskExpeTitle, _searchText) ||
        this.uiService.normalizeAndCompareStrings(descDivisions, _searchText) ||
        this.uiService.normalizeAndCompareStrings(descExpte, _searchText);

      // PASO 2. FILTRO POR TIPO DE TAREA (GRAFICO 1)
      if (_filterTipoTarea) {
        isValidTask = isValidTask && task.type === _filterTipoTarea;
        //                    (this.traduce(task.type) === _filterTipoTarea);
      }
      if (_filterTipoExpediente) {
        isValidTask = isValidTask && task?.division?.procedure?.identifier === _filterTipoExpediente;
        //                    (this.traduce(task.type) === _filterTipoTarea);
      }
      if (_filterTipoContrato) {
        isValidTask = isValidTask && task?.division?.project?.classification?.typeCode?.identifier === _filterTipoContrato;
        //                    (this.traduce(task.type) === _filterTipoTarea);
      }

      // PASO 3. FILTRO POR FECHA
      if (_filterDate) {
        let dateGroup: Array<string> = task['DATEGROUP'];

        let estaEngrupo = false;
        if (dateGroup) {
          try {
            estaEngrupo = dateGroup.filter(_grp => {
              return _grp === _filterDate
            }).length != 0;
          } catch {
            console.log('Error con este grupo', dateGroup);
          }
        }

        isValidTask = isValidTask && estaEngrupo;
      }

      // PASO 4. FILTRO POR BUZON
      if (_filterBuzon) {
        isValidTask =
          isValidTask && task.inbox.identifier === _filterBuzon.identifier;
      }

      return isValidTask;
    });
    this.clasificaPorExpediente();
    this.clasificaPorFecha();
    this.clasificaPorBuzon();
    this.loadCharts();
  }

  setDossierFilter(dossier) {
    this.filterByText(dossier.project.contractFolderId);
    this.closeDossierFilter();
  }

  filterDossierByText() {

    if (this.textDossierFilter !== undefined
      && (this.textDossierFilter === '' || this.textDossierFilter.length >= this.MIN_SEARCH_TEXT_LENGHT)) {

      if (this.textDossierFilter !== undefined && this.textDossierFilter === '') {

        // Se hace una copia para tener siempre el original sin filtrar
        this.clonedDossierList = JSON.parse(JSON.stringify(this.dossiersList));

      } else {

        this.clonedDossierList = this.dossiersList.filter(dossierElement => {
          let dossier = dossierElement?.dossier;
          let identifier = dossier?.project?.identifier || '';
          let contractFolderId = dossier?.contractFolderId || dossier?.project?.contractFolderId || '';
          let description = dossier?.project?.name || '';
          let expedieteId = dossier?.project?.title || '';

          let isValidTask = !this.textDossierFilter ||
            this.uiService.normalizeAndCompareStrings(identifier, this.textDossierFilter) ||
            this.uiService.normalizeAndCompareStrings(contractFolderId, this.textDossierFilter) ||
            this.uiService.normalizeAndCompareStrings(description, this.textDossierFilter) ||
            this.uiService.normalizeAndCompareStrings(expedieteId, this.textDossierFilter);

          // this.activeFilter = strFilter.replace(/undefined/g, '') !== '';
          return isValidTask;
        });
      }
    }

  }


  openDossierFilter() {
    this.clonedDossierList = lodash.cloneDeep(this.dossiersList);
    this.clonedDossierList.sort((a, b) => {

      let textoA = a?.dossier?.contractFolderId ? a?.dossier?.contractFolderId
        : a?.dossier?.project?.contractFolderId
          ? a?.dossier?.project?.contractFolderId : a?.dossier?.project?.divison?.contractFolderId;
      if (textoA === undefined) { textoA = a.dossier.identifier };

      let textoB = b?.dossier?.contractFolderId ? b?.dossier?.contractFolderId
        : b?.dossier?.project.contractFolderId
          ? b?.dossier?.project?.contractFolderId : b?.dossier?.project?.divison?.contractFolderId;
      if (textoB === undefined) { textoB = b.dossier.identifier };


      // console.log('textoA:' + a.dossier.identifier + '-' + a.dossier.contractFolderId + '->' + textoA);
      // console.log('textoB:' + b.dossier.identifier + '-' + b.dossier.contractFolderId + '->' + textoB);



      return textoA < textoB
        ? -1
        : textoA > textoB
          ? 1
          : 0


    }

    );
    this.textDossierFilter = '';
    this.showDossierFilter = true;
  }

  closeDossierFilter() {
    this.showDossierFilter = false;
  }

  clasificaPorExpediente(): void {
    let _dossierList: Array<any> = [];
    this.filteredTasks.forEach((task: TaskDTO) => {
      let dossierInList = _dossierList.find(dossierEntry =>
        dossierEntry.dossier.identifier.substring(dossierEntry.dossier.identifier.indexOf('<>')) ===
        task.division.identifier.substring(task.division.identifier.indexOf('<>')));

      if (!dossierInList) {
        _dossierList.push({
          dossier: task.division,
          count: 1
        });
      } else {
        dossierInList.count++;
      }
    });
    this.dossiersList = _dossierList;
  }

  clasificaPorFecha(): void {
    let _TODAYCOUNT = 0;
    let _YESTERDAYCOUNT = 0;
    let _WEEKCOUNT = 0;
    let _MONTHCOUNT = 0;
    let _YEARCOUNT = 0;
    let _OLDCOUNT = 0;

    this.filteredTasks.forEach((task: TaskDTO) => {
      //        this.tasks.forEach ((task:TaskDTO)=>{
      let currentTime: Date = new Date();

      let yesterdayTime = new Date();
      yesterdayTime.setDate(currentTime.getDate() - 1);

      let firstDayOfTheWeekTime = new Date();
      firstDayOfTheWeekTime.setDate(
        currentTime.getDate() - currentTime.getDay()
      );

      let taskDate = new Date(task.arrivalDate);

      task['DATEGROUP'] = [];
      if (
        taskDate.getFullYear() === currentTime.getFullYear() &&
        taskDate.getDate() === currentTime.getDate() &&
        taskDate.getMonth() === currentTime.getMonth()
      ) {
        task['DATEGROUP'].push('TODAY');
        _TODAYCOUNT++;
      }

      if (
        taskDate.getFullYear() === currentTime.getFullYear() &&
        taskDate.getDate() === currentTime.getDate() - 1 &&
        taskDate.getMonth() === currentTime.getMonth()
      ) {
        task['DATEGROUP'].push('YESTERDAY');
        _YESTERDAYCOUNT++;
      }

      if (taskDate >= firstDayOfTheWeekTime) {
        task['DATEGROUP'].push('WEEK');
        _WEEKCOUNT++;
      }

      if (
        taskDate.getFullYear() === currentTime.getFullYear() &&
        taskDate.getMonth() === currentTime.getMonth()
      ) {
        task['DATEGROUP'].push('MONTH');
        _MONTHCOUNT++;
      }

      if (taskDate.getFullYear() === currentTime.getFullYear()) {
        task['DATEGROUP'].push('YEAR');
        _YEARCOUNT++;
      }

      if (task['DATEGROUP'].length === 0) {
        task['DATEGROUP'].push('OLD');
        _OLDCOUNT++;
      }

    });
    this.TODAYCOUNT = _TODAYCOUNT;
    this.YESTERDAYCOUNT = _YESTERDAYCOUNT;
    this.WEEKCOUNT = _WEEKCOUNT;
    if (_TODAYCOUNT + _YESTERDAYCOUNT === _WEEKCOUNT) {
      this.WEEKCOUNT = 0;
    }
    this.MONTHCOUNT = _MONTHCOUNT;
    if (_WEEKCOUNT === _MONTHCOUNT) {
      this.MONTHCOUNT = 0;
    }
    this.YEARCOUNT = _YEARCOUNT;
    if (_MONTHCOUNT === _YEARCOUNT) {
      this.YEARCOUNT = 0;
    }
    this.OLDCOUNT = _OLDCOUNT;
  }

  clasificaPorBuzon(): void {
    let _buzonesList: Array<any> = [];
    this.filteredTasks.forEach((task: TaskDTO) => {
      let nuevoBuzon = true;
      _buzonesList.forEach((buzon: any) => {
        let taskInbox = '-';
        // por si el buzon llega nulo
        if (task['inbox']) {
          taskInbox = task['inbox'].identifier;
        }

        if (buzon.identifier === taskInbox) {
          nuevoBuzon = false;
          buzon.count = buzon.count + 1;
        }
      });

      // si es un buzon nuevo lo añado a la lista
      if (nuevoBuzon) {
        let buzon = task['inbox'];
        let idBuzon = buzon ? buzon.identifier : '-';
        let descBuzon = buzon ? buzon.name : 'Descripción no disponible';
        _buzonesList.push({
          identifier: idBuzon,
          description: descBuzon,
          count: 1
        });
      }
    });
    this.buzonesList = _buzonesList;
  }

  openTask(task: TaskDTO): void {
    this.taskService.openTask(task);
  }

  public clear() {
    this.filteredTasks = this.tasks;
    this.userPrefs.tasksViewPrefs.filters.filterTipoTarea = '';
    this.userPrefs.tasksViewPrefs.filters.filterText = '';
    this.userPrefs.tasksViewPrefs.filters.filterDate = '';
    this.userPrefs.tasksViewPrefs.filters.filterTipoExpediente = '';
    this.userPrefs.tasksViewPrefs.filters.filterTipoContrato = '';
    this.updateFilter();
  }

  filterByTipoTarea(e: any) {
    let index = -1;
    if (typeof e === 'number') {
      index = e;
    }
    if (index >= 0) {
      this.userPrefs.tasksViewPrefs.filters.filterTipoTarea = this.chartTipoTareaKeys[
        index
      ];
    } else {
      delete this.userPrefs.tasksViewPrefs.filters.filterTipoTarea;
    }
    this.updateFilter();
  }

  filterByTipoExpediente(e: any) {
    let index = -1;
    if (typeof e === 'number') {
      index = e;
    }
    if (index >= 0) {
      // this.filterTipoExpedienteDescription = this.chartTipoExpedienteLabels[index];
      this.userPrefs.tasksViewPrefs.filters.filterTipoExpediente = this.chartTipoExpedienteKeys[
        index
      ];
    } else {
      // this.filterTipoExpedienteDescription = '';
      delete this.userPrefs.tasksViewPrefs.filters.filterTipoExpediente;
    }
    this.updateFilter();
  }

  filterByTipoContrato(e: any) {
    let index = -1;
    if (typeof e === 'number') {
      index = e;
    }
    if (index >= 0) {
      // this.filterTipoContratoDescription = this.chartTipoContratoLabels[index];
      this.userPrefs.tasksViewPrefs.filters.filterTipoContrato = this.chartTipoContratoKeys[
        index
      ];
    } else {
      // this.filterTipoExpedienteDescription = '';
      delete this.userPrefs.tasksViewPrefs.filters.filterTipoContrato;
    }
    this.updateFilter();
  }
  filterByText(text: string) {
    this.userPrefs.tasksViewPrefs.filters.filterText = text;
    this.updateFilter();
  }

  filterByDate(filtro: string) {
    this.userPrefs.tasksViewPrefs.filters.filterDate = filtro;
    this.updateFilter();
  }

  filterByBuzon(buzon: InboxDTO) {
    this.userPrefs.tasksViewPrefs.filters.filterBuzon = buzon;
    this.updateFilter();
  }
  // _chartOptions: any;

  loadCharts(): void {
    // UPDATE CHARTS
    if (this.filteredTasks && this.filteredTasks.length > 0) {
      this.chartTipoTareaLabels = [];
      this.chartTipoTareaData = [];
      this.chartTipoTareaKeys = [];

      this.chartTipoExpedienteLabels = [];
      this.chartTipoExpedienteData = [];
      this.chartTipoExpedienteKeys = [];

      this.chartTipoContratoLabels = [];
      this.chartTipoContratoData = [];
      this.chartTipoContratoKeys = [];

      this.filteredTasks.forEach(this.agruparTareasParaGraficos, this);
    } else {
      this.chartTipoTareaLabels = ['Sin datos'];
      this.chartTipoTareaData = [1];

      this.chartTipoExpedienteLabels = ['Sin datos'];
      this.chartTipoExpedienteData = [1];

      this.chartTipoContratoLabels = ['Sin datos'];
      this.chartTipoContratoData = [1];
    }

    setTimeout(() => {
      this.chartTipoTareaLabels = this.chartTipoTareaLabels.slice();
      this.chartTipoExpedienteLabels = this.chartTipoExpedienteLabels.slice();
      this.chartTipoContratoLabels = this.chartTipoContratoLabels.slice();

      this._chartTipoTareaData = {
        labels: this.chartTipoTareaLabels,
        datasets: [
          {
            label: '',
            data: this.chartTipoTareaData,
            backgroundColor: this.uiService.backgroundColor,
            borderColor: this.uiService.borderColor,
            borderWith: 2,
            options: this.uiService.barChartOptions
          }
        ]
      };
      this._chartTipoExpedienteData = {
        labels: this.chartTipoExpedienteLabels,
        datasets: [
          {
            label: '',
            data: this.chartTipoExpedienteData,
            backgroundColor: this.uiService.backgroundColor,
            borderColor: this.uiService.borderColor,
            borderWith: 2,
            options: this.uiService.barChartOptions
          }
        ]
      };
      this._chartTipoContratoData = {
        labels: this.chartTipoContratoLabels,
        datasets: [
          {
            label: '',
            data: this.chartTipoContratoData,
            backgroundColor: this.uiService.backgroundColor,
            borderColor: this.uiService.borderColor,
            borderWith: 2,
            options: this.uiService.barChartOptions
          }
        ]
      }
    }, 5);
  }

  public agruparTareasParaGraficos(t: TaskDTO) {
    this.clasificarTareas(
      t,
      this.chartTipoTareaField,
      null,
      this.chartTipoTareaLabels,
      this.chartTipoTareaData,
      this.chartTipoTareaKeys
    );

    this.clasificarTareas(
      t,
      this.chartTipoExpedienteField,
      this.chartTipoExpedienteFieldDescription,
      this.chartTipoExpedienteLabels,
      this.chartTipoExpedienteData,
      this.chartTipoExpedienteKeys
    );

    this.clasificarTareas(
      t,
      this.chartTipoContratoField,
      this.chartTipoContratoFieldDescription,
      this.chartTipoContratoLabels,
      this.chartTipoContratoData,
      this.chartTipoContratoKeys
    );
  }

  private clasificarTareas(task: TaskDTO, field: string, fieldDescription: string, labels: any, data: any, keys: any) {
    let tipo: string = this.formService.getNestedProperty(task, field);
    if (tipo) {
      // TODO: AQUI SI HAY QUE TRADUCIR
      let idx: number = keys.indexOf(tipo);
      if (idx === -1) {
        idx = keys.length;
        if (!fieldDescription) {
          labels[idx] = this.traduce(tipo);
        } else {
          labels[idx] = this.formService.getNestedProperty(task, fieldDescription);
        }
        keys[idx] = tipo;
      }

      let num: number = data[idx];
      if (!num) {
        num = 0;
      }
      data[idx] = ++num;
    }
  }

  // Traduccion de la descripcion del tipo tarea. Debe venir del servidor por expansion.
  // Solucion temporal porque actualmente no es posible (el campo type es un enum en el api)
  traduce(idTipo: TaskTypeDTO) {
    let texto = 'otro';
    this.subscribe(this.translate.get('PendingTasks.' + idTipo),
      (res: string) => {
        texto = res;
      });
    return texto;
  }

  traduceTipoExpediente(idTipo) {
    let index = this.chartTipoExpedienteKeys.findIndex(_type => _type === idTipo);
    if (index !== -1) {
      return this.chartTipoExpedienteLabels[index];
    } else {
      return '-'
    }
  }

  traduceTipoContrato(idTipo) {
    let index = this.chartTipoContratoKeys.findIndex(_type => _type === idTipo);
    if (index !== -1) {
      return this.chartTipoContratoLabels[index];
    } else {
      return '-'
    }
  }

  /**********************************************************************************************/
  /**********************************************************************************************/
  openDossier(task: TaskDTO): void {
    this.uiService.openDossier(dossierBasicInfoComponent, task.dossier);
  }

  exportCSV() {
    let export_columns =
      'export_columns='

      + this.translate.instant('General.project') + ':division.project.contractFolderId,'
      + this.translate.instant('Audit.task') + ':description,'
      + this.translate.instant('DossierBasicInfo.title') + ':division.project.title,'
      + this.translate.instant('PendingTasks.arrival') + ':arrivalDate,'
      + this.translate.instant('PendingTasks.endDate') + ':expirationDate';
    this.subscribe(this.taskService.getCSVTasks(export_columns));
  }

  openMultiSignatureComponent(): void {
    let config: DynamicDialogConfig = {
      header: this.translate.instant('MultiSignature.document.signature'),
      width: '75%',
      style: { overflow: 'hidden', 'max-height': '90%' },
      styleClass: 'formEdition',
      closeOnEscape: false
    };
    const dialog = this.dialogService.open(multiSignatureComponent, config);
    this.subscribe(dialog.onClose,
      () => {
        this.subscribe(this.helpService.showContextHelpObservable(HelpType.HELP_TASKS));
      });
  }

  // METODOS PARA RELACION CON EL COMPONENTE QUE PINTA LA TABLA CON LAS TAREAS (taskListComponent)
  reloadRowCounter(ev: any) {
    this.rows = ev;

  }
  reloadTotalCounter(ev: any) {
    this.totalRecords = this?.tasks?.length;
  }

  changeGroup(evt) {
    this.userPrefs.tasksViewPrefs.filters.groupBy = this.selectedGroup.code;
    this.updateTasksList();
  }
}
